(function () {
  if (window.__ucOfferAnalyticsBound) return;
  window.__ucOfferAnalyticsBound = true;

  var eventNames = {
    modalOpen: 'ucBottleListModalOpened',
    quantity: {
      content: 'ucQuantitySelectedContent',
      modal: 'ucQuantitySelectedModal',
      sticky: 'ucQuantitySelectedSticky'
    },
    buyNow: {
      content: 'ucBuyNowContentClicked',
      modal: 'ucBuyNowModalClicked',
      sticky: 'ucBuyNowStickyClicked'
    }
  };

  var surfaceAliases = {
    'description-modal': 'modal'
  };

  function scopeContext(scope) {
    var checked = scope ? scope.querySelector('input[data-uc-analytics-quantity]:checked') : null;
    var interactionSurface = scope ? scope.getAttribute('data-uc-analytics-surface') || 'content' : 'content';
    return {
      surface: surfaceAliases[interactionSurface] || interactionSurface,
      interactionSurface: interactionSurface,
      component: scope ? scope.getAttribute('data-uc-analytics-component') || null : null,
      quantity: checked ? Number(checked.value) : null,
      productId: scope ? scope.getAttribute('data-uc-product-id') || null : null,
      variantId: scope ? scope.getAttribute('data-uc-variant-id') || null : null,
      template: scope ? scope.getAttribute('data-uc-template') || null : null
    };
  }

  function emit(name, context) {
    if (!name) return;
    var payload = Object.assign({ event: name, timestamp: new Date().toISOString() }, context || {});
    if (Array.isArray(window.igEvents)) {
      window.igEvents.push(payload);
    } else if (window.igEvents && Array.isArray(window.igEvents.igEvents)) {
      window.igEvents.igEvents.push(payload);
    } else {
      window.igEvents = [payload];
    }
    window.dispatchEvent(new CustomEvent('uc:offer-analytics', { detail: payload }));

  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('input[data-uc-analytics-quantity]');
    if (!input || !event.isTrusted || !input.checked || input.disabled) return;
    var scope = input.closest('[data-qty-scope]');
    var context = scopeContext(scope);
    context.quantity = Number(input.value);
    emit(eventNames.quantity[context.surface], context);
  }, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-uc-analytics-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    var scope = button.closest('[data-qty-scope]');
    var context = scopeContext(scope);
    emit(eventNames.buyNow[context.surface], context);
  }, true);

  window.addEventListener('uc:bottle-list-modal-open', function (event) {
    var detail = event.detail || {};
    var modal = detail.modalId ? document.getElementById(detail.modalId) : null;
    var scope = modal ? modal.querySelector('[data-qty-scope]') : null;
    var context = scopeContext(scope);
    context.modalId = detail.modalId || null;
    context.source = detail.source || 'generic';
    emit(eventNames.modalOpen, context);
  });
})();
